import {DomainObject} from 'shared/store';
import { observable, action, computed, makeObservable } from 'mobx';
import {rangeDate} from 'shared/tools';
import {Employee} from 'main/stores/employees';
import TrainingProgram from './TrainingProgram';
import Answer from './Answer';
import _ from 'lodash';

class EmployeeTrainingStatus extends DomainObject {
  id;
  employee;
  program;
  dueDate;
  completedAt;
  completed;

  _relations = {
    employee: Employee,
    program: TrainingProgram,
    answers: [Answer],
    _dates: ['dueDate', 'completedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      employee: observable,
      program: observable,
      dueDate: observable,
      completedAt: observable,
      completed: observable,
      readOnly: computed,
      dueDateView: computed,
      completedAtView: computed,
      quizScore: computed,
      quizResultsView: computed,
      regenerateAnswersForQuestions: action
    });

    this.merge(other);
  }

  get readOnly() {
    return !this.hasLink('complete');
  }

  get dueDateView() {
    return rangeDate(this.dueDate);
  }

  get completedAtView() {
    return rangeDate(this.completedAt);
  }

  get quizScore() {
    if (!this.totalAnswerCount) return '--';

    return Math.round(this.correctAnswerCount / this.totalAnswerCount * 100);
  }

  get quizResultsView() {
    if (!this.totalAnswerCount) return '--';

    return `${this.quizScore}% [${this.correctAnswerCount}/${this.totalAnswerCount}]`;
  }

  regenerateAnswersForQuestions(questions) {
    let newAnswers = [];
    let currentAnswers = _.keyBy(this.answers, 'question.id');

    _.forEach(questions, q => {
      let answer = new Answer({question: q});
      if (currentAnswers[q.id] !== undefined) {
        answer.value = currentAnswers[q.id].value;
      }
      newAnswers.push(answer);
    });

    this.answers = newAnswers;
  }
}

export default EmployeeTrainingStatus;
